import callCmAPI from 'services/helpers/call-cm-api'
import { Zone, WebApi2Response } from 'types'

/******************
 * Fetch from API *
 ******************/

export type CreateZoneArgs = {
  name: string
  // The resolved, de-duplicated country set for the new zone.
  countries: string[]
}

// Creates a reusable custom global zone via the CMAPI write proxy
// (POST /global-data/create-zone -> RisikaAPI /zone/add). RisikaAPI enforces
// the name constraint and rejects duplicate names; those surface as the error
// branch below and are turned into a snackbar by the mutation hook.
export const createZone = (
  body: CreateZoneArgs,
): Promise<WebApi2Response<Zone>> =>
  callCmAPI('/global-data/create-zone', {
    method: 'post',
    data: body,
  })
    .then((res) => {
      return { success: true as const, data: res.data as Zone }
    })
    .catch((err) => {
      return {
        success: false as const,
        data: null,
        error: err,
      }
    })
